import { all, call, put, takeLatest } from "redux-saga/effects";

import {
  getNewsTabsStart,
  getNewsTabsSuccess,
  getNewsTabsFailed,
} from "../redux/getNewsTabs";

import { getNewsTabsApi } from "core/http/service/news";

function* getNewsTabsWork() {
  try {
    const res = yield call(getNewsTabsApi);

    yield put({
      type: getNewsTabsSuccess.type,
      payload: res.data,
    });
  } catch (error: any) {
    yield put({
      type: getNewsTabsFailed.type,
    });
  }
}

function* watchGetNewsTabs() {
  yield takeLatest(getNewsTabsStart.type, getNewsTabsWork);
}

export default function* getNewsTabsSaga() {
  yield all([watchGetNewsTabs()]);
}
